import { maxLength, required, TextInput, useNotify, useRecordContext } from "react-admin";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import { Grid } from "@mui/material";

import { settings } from "app";
import { erasmusRequests } from "api/erasmusApi";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import FormModal from "server/components/Modals/FormModal";
import { documentErrorMessage } from "server/components/DownloadFile";
import { download } from "server/download";
import { toDateOnly } from "utils/helpers";

// The protocol is generated from data the service does not keep - the contract number and the list
// of attached documents are typed in every time, so the POST carries them and returns the pdf.
const SelectionProtocolDialog = ({ label = "Протокол за селекция" }) => {
  const record = useRecordContext();
  const notify = useNotify();

  if (!record) return null;

  const handleConfirm = async data => {
    const attachedDocuments = data.attachedDocuments?.trim();

    const payload = {
      ContractNumber: data.contractNumber?.trim(),
      // both are optional - leave them out entirely so the backend applies its own defaults
      ...(attachedDocuments ? { AttachedDocuments: attachedDocuments } : {}),
      ...(data.protocolDate ? { ProtocolDate: toDateOnly(data.protocolDate) } : {}),
    };

    try {
      await download(
        `${settings.gatewayApi}/${erasmusRequests.postCampaignSelectionProtocol(record.id)}`,
        `selection-protocol-${record.id}.pdf`,
        "POST",
        payload,
      );
    } catch (err) {
      // keep the modal open so the entered data can be corrected and the download retried
      notify(documentErrorMessage(err), { type: "error" });
      return false;
    }
  };

  return (
    <FormModal
      titleContent={label}
      dialogSize="md"
      saveTitle="Генерирай"
      onConfirm={handleConfirm}
      startIcon={<FactCheckIcon />}
      titleButton={label}
      btnStyle={{ width: "max-content" }}
      variant="contained"
    >
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <TextInput
            source="contractNumber"
            label="Номер на договора"
            fullWidth
            validate={[required(), maxLength(100)]}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <CustomDateInput
            source="protocolDate"
            label="Дата на протокола"
            noTime
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <TextInput
            source="attachedDocuments"
            label="Приложени документи"
            sx={settings.style.textAria}
            variant="outlined"
            fullWidth
            multiline
            validate={[maxLength(1000)]}
          />
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default SelectionProtocolDialog;
